// MainContent.jsx
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { MainBoxes } from "./mainboxes";
import "./main.css";


const API_KEY = process.env.REACT_APP_API_URL

function MainContent() {
  const { id } = useParams();
  const location = useLocation();

  const [allApps, setAllApps] = useState([]);
  const [tools, setTools] = useState([]);
  const [categoryName, setCategoryName] = useState(location.state?.categoryName || "");
  const [loading, setLoading] = useState(true);

  // Step 1: Fetch all apps once
  useEffect(() => {
    const fetchApps = async () => {
      try {
        const res = await fetch(`${API_KEY}/api/apps`);
        const data = await res.json();
        setAllApps(data.apps || []);
      } catch (err) {
        console.error("Error fetching apps:", err);
      }
    };

    fetchApps();
  }, []);

  // Step 2: Filter tools once apps + categoryName available
  useEffect(() => {

    if (allApps.length === 0) return;

    const filterByCategory = () => {
      let actualCategory = categoryName;
      // If categoryName is still empty, get it from the current app
      if (!actualCategory) {
        const currentApp = allApps.find((app) => app._id === id);
        if (currentApp?.category_id?.name) {
          actualCategory = currentApp.category_id.name;
          setCategoryName(actualCategory); // Update state
        }
      }

      if (actualCategory) {
        const filtered = allApps.filter(
          (app) =>
            app.category_id?.name?.toLowerCase() ===
            actualCategory.toLowerCase()
        );
        setTools(filtered);
      } else {
        setTools([]);
      }

      setLoading(false);
    };

    filterByCategory();
  }, [allApps, id, categoryName]);

  return (
    <div className="main-area-box">
      <div className="tags-area">
        {categoryName && <h2 className="text-center mt-4">{categoryName}</h2>}
      </div>

      <div className="row g-4">
        {tools.map((tool) => (
          <div key={tool._id} className="col-md-6 col-lg-4">
            <div
              className="card h-100 border-0 shadow-sm rounded-4"
              style={{
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              // onClick={() => window.open(tool.link, "_blank")}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.02)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <div className="card-body d-flex flex-column">
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={tool.company_logo}
                    alt="Logo"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <h5
                    className="ms-3 mb-0 fw-bold text-primary"
                    style={{ fontSize: "1rem" }}
                  >
                    {tool.name}
                  </h5>
                </div>
                <p className="text-muted" style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                  {tool.description?.length > 100
                    ? tool.description.slice(0, 100) + "..."
                    : tool.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>


    </div>
  );
}

export default MainContent;
